















import Vue from 'vue';
import { NavStepState } from '../../lib/enums/navStepState';
export default Vue.extend({
  name: 'NavSteps',
  props: {
    steps: {
      type: Array,
      required: true,
      default: function () {
        return [
          {
            name: 'Step 1',
            altText: '1',
            icon: '',
            class: '',
            state: NavStepState.Complete
          },
          {
            name: 'Step 2',
            altText: '2',
            icon: '',
            class: '',
            state: NavStepState.Enabled
          },
          {
            name: 'Step 3',
            altText: '3',
            icon: '',
            class: '',
            state: NavStepState.Disabled
          }
        ];
      }
    }
  }
});
